<script>
import BaseGrid from '@/views/finance/incomes/BaseGrid';

export default {
    title: 'Список безналичных приходов',
    name: 'CashLessGrid',
    extends: BaseGrid,
    data() {
        return {
            headerOptions: {
                isNewButtonVisible: true
            },
            settingName: 'incomes-cashless',
            title: 'Список безналичных приходов',
            isPayTypeFilterVisible: false,
            isCashLess: true
        };
    },
    computed: {
        isIncomeCashLessAccountant() {
            return this.$store.getters.isIncomeCashLessAccountant;
        },
        isIncomesCashLessEmployer() {
            return this.$store.getters.isIncomesCashLessEmployer;
        },
        canCreateIncome() {
            return (this.isIncomeCashLessAccountant || this.isIncomesCashLessEmployer);
        }
    },
    beforeMount() {
        this.filterModel.pay_type_id = this.cashlessPayTypes;
        this.filterModel.received_by_type = 'cash';
        this.filterModel.received_from_type = 'contact';
    },
    methods: {
        onSelectionChanged(e) {
            this.$router.push({ name: 'income-cashless-card-view', params: { id: '' + e.node.data.id } });
        },
        goNewCard() {
            this.$router.push({ name: 'income-cashless-card', params: { id: 'new' } });
        }
    }
};
</script>
